import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatCheckboxRequiredValidator } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/app-config.service';
import { finalize } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { CommonService } from 'src/app/common.service';
import { TranslateService } from '@ngx-translate/core';
import { error } from 'protractor';
import { ConfirmDialogComponent } from 'src/app/common/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-login-popup',
  templateUrl: './login-popup.component.html',
  styleUrls: ['./login-popup.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class LoginPopupComponent implements OnInit {
  appConfig: any;
  userEmailId: string = '';
  userPassword: string = '';
  hide: boolean = true;
  invalidUserCredentials: boolean = false;
  currentUser: any = {};
  IschangePassword = false;
  isOtpSend = false;
  isotpSumitted = false;
  isPasswordConfirmed = false;
  isforgetPassword: boolean = false;
  isCodeVerified: boolean = false;
  forgetPasswordObj: any = {
    emailId: '',
    newPassword: '',
    confirmedPassword: '',
    verificationCode: ''
  };
  changePasswordObj: any = {
    oldPassword: '',
    newPassword: '',
    confirmedPassword: '',
  }
  hideNwPassword: boolean = true;
  hideConfirmPassword: boolean = true;
  hideOldPassword: boolean = true;
  showLoader: boolean = false;
  @ViewChild('emailInput') emailInput: ElementRef | null = null;


  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    // Do something
    if (!this.data.isAccessTokenExpired && this.commonService.ProjectLSData['currentRoute'] && (this.commonService.ProjectLSData['currentRoute'].indexOf('/login') < 0)) {
      this.dialogRef.close();
    }
  }

  constructor(public dialogRef: MatDialogRef<LoginPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private router: Router,
    public configService: AppConfigService,
    private commonService: CommonService,
    private dialog: MatDialog,
    public translate: TranslateService) {
    this.appConfig = configService.config;
    this.translate.addLangs(['en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {
    this.IschangePassword = this.data.changePassword ? this.data.changePassword : false;
    this.isOtpSend = false;
    this.isotpSumitted = false;
    this.isPasswordConfirmed = false;

    this.currentUser = this.commonService.ProjectLSData['currentUser'];
    if (this.data.isAccessTokenExpired) {
      this.userEmailId = this.currentUser.email;
    }
  }

  validateLogin(discardOldSession: boolean) {
    this.invalidUserCredentials = false;
    let userCredentials = {
      "email": this.userEmailId,
      "password": this.userPassword,
      "discardOldSession": discardOldSession
    };

    this.authService.login(userCredentials).subscribe((res: any) => {
      if (res == "true") {
        this.authService.getUserInfo().subscribe((res: any) => {
          if (res?.data) {
            this.commonService.ProjectLSData["currentUser"] = res?.data;
            this.commonService.setProjectLSData();
            this.authService.getUserRoles().subscribe((response: any) => {
              if (response != "") {
                let roleArr = [];
                for (let i = 0; i < response.length; i++) {
                  roleArr.push({
                    role: response[i],
                    roleDisplayText: (response[i] === "APPLICATION_ADMIN") ? 'Application Admin' : 'Pathologist'
                  });
                }
                this.commonService.ProjectLSData["userRoleList"] = roleArr;
                this.dialogRef.close({ loginStatus: 'success' });
                if (location.pathname.includes("/login")) {
                  delete this.commonService.ProjectLSData['currentRoute'];
                  this.commonService.setProjectLSData();
                  this.router.navigate([`/mainboard/${(roleArr[0]?.role == "APPLICATION_ADMIN") ? 'users' : 'patientList'}`]);
                }
              } else {
                this.authService.logout();
              }
            });
          }
        });
      } else if (res == "discardOldSession") {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = "30%";
        dialogConfig.panelClass = "confirmDialog";
        dialogConfig.data = {
          headerTitle: "Logout",
          confirmMsg: this.translate.instant("USER_CONFIGURATION.Already_Active_Session"),
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmActionData: {
            currentPage: 'login'
          }
        };
        const dialogref = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogref.afterClosed().subscribe((result: any) => {
          if (result == 'yes') {
            this.validateLogin(true);
          }
        })
      }
      else {
        this.invalidUserCredentials = true;
      }
    });
  }

  forgetPassword() {
    this.IschangePassword = true;
  }

  validateEmail() {
    this.isOtpSend = true;
  }

  submitOtp() {
    this.isotpSumitted = true;
  }

  submitPassword() {
    this.isPasswordConfirmed = true;
  }

  reloadOnInit() {
    this.ngOnInit();
  }

  CancelLogin() {
    this.dialogRef.close();
    delete this.commonService.ProjectLSData['currentRoute'];
    this.commonService.setProjectLSData();
    this.router.navigate(['']);
  }

  enableForgetPassword() {
    this.isforgetPassword = true;
  }

  sendEmail() {
    // this.isOtpSend = true;
    console.log(this.emailInput?.nativeElement.validity.valid);
    this.showLoader = true;
    this.commonService.sendEmailForVerification(this.forgetPasswordObj.emailId).pipe(finalize(() => this.showLoader = false)).subscribe((response: any) => {
      if (response.success) {
        this.isOtpSend = true;
      }
    }, (erro: any) => {
      this.showLoader = false;
    })
  }
  confirmedPassword() {
    this.isforgetPassword = this.isOtpSend = this.isCodeVerified = false;
  }

  verifyCode() {
    this.commonService.verifyCode({
      userId: this.forgetPasswordObj.emailId,
      verificationCode: this.forgetPasswordObj.verificationCode
    }).subscribe((res: any) => {
      if (res.success)
        this.isCodeVerified = true;
    })
  }

  setNewPassword() {
    if (this.forgetPasswordObj.newPassword == this.forgetPasswordObj.confirmedPassword) {
      if (this.forgetPasswordObj.newPassword.length < 8) {
        this.commonService.showToastMsg(this.translate.instant("USER_CONFIGURATION.Min_Password_Length"));
        return;
      };
      if (this.forgetPasswordObj.newPassword.length > 16) {
        this.commonService.showToastMsg(this.translate.instant("USER_CONFIGURATION.Max_Password_Length"));
        return;
      } let resetPasswordSevice = this.IschangePassword ? this.commonService.changePassword({
        oldPassword: this.forgetPasswordObj.oldPassword,
        newPassword: this.forgetPasswordObj.newPassword
      }) : this.commonService.resetPassword({
        email: this.forgetPasswordObj.emailId,
        password: this.forgetPasswordObj.newPassword
      });
      resetPasswordSevice.subscribe((res: any) => {
        if (res.success) {
          this.isforgetPassword = this.isOtpSend = this.isCodeVerified = false;
          this.commonService.showToastMsg(res.message);
          if (this.IschangePassword) {
            this.dialogRef.close();
          } else {
            this.closeForgetPassword();
          }
          this.forgetPasswordObj = {
            emailId: '',
            verificationCode: '',
            oldPassword: '',
            newPassword: '',
            confirmedPassword: ''
          }
        }
      }, (err: any) => {
        this.commonService.showToastMsg(err.message);
      }
      )
    } else {
      this.commonService.showToastMsg(this.translate.instant("USER_CONFIGURATION.New_Password_Match_Error"));
    }

  }
  closeForgetPassword() {
    this.forgetPasswordObj = {
      emailId: '',
      newPassword: '',
      confirmedPassword: '',
      verificationCode: '',
    }
    this.isOtpSend = this.isCodeVerified = this.isforgetPassword = false;
  }
  cancelChangePassword() {
    this.changePasswordObj = {
      oldPassword: '',
      newPassword: '',
      confirmedPassword: '',
    }
    this.dialogRef.close();

  }
  resetPassword() {
    if (this.changePasswordObj.newPassword == this.changePasswordObj.confirmedPassword) {
      this.commonService.changePassword({
        oldPassword: this.changePasswordObj.oldPassword,
        newPassword: this.changePasswordObj.newPassword
      }).subscribe((res: any) => {
        if (res) {
          this.commonService.showToastMsg(res.message);
          this.dialogRef.close();
        }
      })
    }
  }
}

